"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:no-console */
const ow_1 = require("ow");
const LiveLogConfig_1 = require("./config/LiveLogConfig");
const LogLevel_1 = require("./config/LogLevel");
const LogMetadata_1 = require("./config/LogMetadata");
const StaticConfig_1 = require("./config/StaticConfig");
const ParseLogMsg_1 = require("./parse/ParseLogMsg");
/**
 * Logging levels conforms NPM logging levels
 */
class AbstractUniverseLog {
    constructor(props) {
        this.instanceMetadata = LogMetadata_1.LogMetadata.EMPTY_METADATA;
        if (props.metadata) {
            ow_1.default(props.metadata, "metadata", ow_1.default.object);
            this.instanceMetadata = props.metadata;
        }
        if (props.logFn) {
            this.logFn = props.logFn;
        }
        else {
            this.logFn = StaticConfig_1.StaticConfig.DEFAULT_LOG_FN;
        }
        ow_1.default(this.logFn, "logFn", ow_1.default.function);
        ow_1.default(props.levelEnvs, "levelEnvs", ow_1.default.object);
        this.liveConfig = new LiveLogConfig_1.LiveLogConfig(props.levelEnvs, (msg) => this.logFn(msg));
    }
    init(logLevelEnvs) {
        if (logLevelEnvs) {
            this.liveConfig.setLevelEvaluationEnvNames(logLevelEnvs);
        }
        this.reevaluateConfigIfRequired();
    }
    getLevel() {
        return this.liveConfig.getLevel();
    }
    getFormatName() {
        return this.liveConfig.getFormat().getName();
    }
    getMetadata() {
        return Object.assign({}, this.instanceMetadata, this.liveConfig.getMetadata());
    }
    isDebug() {
        const levelThreshold = LogLevel_1.LogLevel.LEVELS_VALUES[this.getLevel()];
        return levelThreshold >= LogLevel_1.LogLevel.LEVELS_VALUES.debug;
    }
    error(...msg) {
        this.doLog(LogLevel_1.LogLevel.error, msg);
    }
    errorGen(genFn) {
        this.doEfficientLog(LogLevel_1.LogLevel.error, genFn);
    }
    warn(...msg) {
        this.doLog(LogLevel_1.LogLevel.warn, msg);
    }
    warnGen(genFn) {
        this.doEfficientLog(LogLevel_1.LogLevel.warn, genFn);
    }
    info(...msg) {
        this.doLog(LogLevel_1.LogLevel.info, msg);
    }
    infoGen(genFn) {
        this.doEfficientLog(LogLevel_1.LogLevel.info, genFn);
    }
    http(...msg) {
        this.doLog(LogLevel_1.LogLevel.http, msg);
    }
    httpGen(genFn) {
        this.doEfficientLog(LogLevel_1.LogLevel.http, genFn);
    }
    verbose(...msg) {
        this.doLog(LogLevel_1.LogLevel.verbose, msg);
    }
    verboseGen(genFn) {
        this.doEfficientLog(LogLevel_1.LogLevel.verbose, genFn);
    }
    debug(...msg) {
        this.doLog(LogLevel_1.LogLevel.debug, msg);
    }
    debugGen(genFn) {
        this.doEfficientLog(LogLevel_1.LogLevel.debug, genFn);
    }
    silly(...msg) {
        this.doLog(LogLevel_1.LogLevel.silly, msg);
    }
    sillyGen(genFn) {
        this.doEfficientLog(LogLevel_1.LogLevel.silly, genFn);
    }
    /**
     * Calls generator fn only if logging level is reached.
     */
    doEfficientLog(level, msgGeneratorFn) {
        this.reevaluateConfigIfRequired();
        const levelThreshold = LogLevel_1.LogLevel.LEVELS_VALUES[this.getLevel()];
        const msgLevel = LogLevel_1.LogLevel.LEVELS_VALUES[level];
        if (msgLevel <= levelThreshold) {
            this.doLog(level, msgGeneratorFn());
        }
    }
    doLog(level, ...msgsObjs) {
        this.reevaluateConfigIfRequired();
        if (msgsObjs.length === 0) {
            return;
        }
        if (msgsObjs.length === 1 && Array.isArray(msgsObjs[0])) {
            msgsObjs = msgsObjs[0];
        }
        if (LogLevel_1.LogLevel.isLessOrEquallyVerbose({ level, threshold: this.getLevel() })) {
            const parsedMessage = ParseLogMsg_1.ParseLogMsg.parse(level, msgsObjs);
            const formattedMessage = this.liveConfig.getFormat().format(parsedMessage, this.getMetadata());
            this.rawWriteToLog(formattedMessage);
        }
    }
    rawWriteToLog(msg) {
        this.logFn(msg);
    }
    reevaluateConfigIfRequired() {
        this.liveConfig.evaluateIfRequired();
    }
}
AbstractUniverseLog.level = LogLevel_1.LogLevel;
exports.AbstractUniverseLog = AbstractUniverseLog;
//# sourceMappingURL=AbstractUniverseLog.js.map